
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import WaterSupplyDistributionNetworkPreventiveWorkPopup from './WaterSupplyDistributionNetworkPreventiveWorkPagePopup'
import { useSearchParams } from 'react-router-dom'
import { DistributionLineLocationDataDDL } from '../../../../../../Components/CommonDDL/DistributionLineLocationDataDDL'
import { JunctionNameDataDDL } from '../../../../../../Components/CommonDDL/JunctionNameDataDDL'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL'
import { WaterSupplyDistributionNetworkDeleteAPI, WaterSupplyDistributionNetworkTableDataAPI, WaterSupplyDistributionNetworkTableExportDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/PreventiveWorkWaterSupply/DistributionNetworkSlice'
import { useDispatch, useSelector } from 'react-redux'
import { Loading } from '../../../../../../Helper/Loading'
import { useAuthState } from '../../../../../../Helper/Context'
import moment from 'moment'
import { WaterSupplyDistributionNetworkPreventiveWorkExportData } from './WaterSupplyDistributionNetworkPreventiveWorkExportPage'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import { TableNote } from '../../../../../../Components/Note/Note'

export default function WaterSupplyDistributionNetworkPreventiveWorkPage() {


    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const dispatch = useDispatch()

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [PumpStationMasterPopupShow, setPumpStationMasterPopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [CurrentPage, setCurrentPage] = useState(0)
    const [PerPageCount, setPerPageCount] = useState(10)
    const [IsClear, setIsClear] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [rowNo, setrowNo] = useState(1)
    const [FromTop, setFromTop] = useState(1)
    const [ToTop, setToTop] = useState(10)
    // const [Date, setDate] = useState(moment().format('YYYY-MM-DD'))

    const date = Month?.ID != 0 && (Month?.ID <= 3 ? moment().month(Month?.ID - 1).format('YYYY-MM-DD') : moment().year(year.ID).month(Month?.ID - 1).date(1).format('YYYY-MM-DD'));
    // const [Date, setDate] = useState(date ? moment(date).startOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'))
    const isCurrentMonth = date && moment(date).isSame(moment(), 'month');
    const [Date, setDate] = useState(date ? (isCurrentMonth ? moment().format('YYYY-MM-DD') : moment(date).startOf('month').format('YYYY-MM-DD')) : moment().format('YYYY-MM-DD'))

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')

    const [WaterSupplyDistributionNetworkPreventiveWorkPopupShow, setWaterSupplyDistributionNetworkPreventiveWorkPopupShow] = useState()

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })
    const [JunctionNameDDL, setJunctionNameDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleEditOnClick = (item) => {
        setWaterSupplyDistributionNetworkPreventiveWorkPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    const handleOnCloseClick = () => {
        setWaterSupplyDistributionNetworkPreventiveWorkPopupShow(false)
    }

    const handleClear = () => {
        setCurrentPage(0)
        setToTop(10)
        setFromTop(1)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
        setJunctionNameDDL({
            ...JunctionNameDDL,
            ID: 0,
            Label: 'Select...',
        })
        setDate(moment().format('YYYY-MM-DD'))
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setToTop(10)
        setFromTop(1)
        setIsSearch(!isSearch)
    }

    useEffect(() => {
        const data = {
            M_Distri_WS_LocationID: JunctionNameDDL.ID,
            ReadingDate: Date,
            token: token,
            FromTop: FromTop,
            ToTop: ToTop,
            M_WardID: WardName.ID,
            // PumpStation: '',
            M_UserID: 1,
            Flag: ApiFlag,
            handleDistributionNetworkExport: handleDistributionNetworkExport
        }
        if (WardName.ID !== 0) {
            dispatch(WaterSupplyDistributionNetworkTableDataAPI({ data }))
        }
    }, [ToTop, IsPost, isSearch, IsClear])

    const { tableData, isLoading } = useSelector(state => state.WaterSupplyDistributionNetworkTableData)

    const handleDistributionNetworkExport = () => {
        const data = {
            M_Distri_WS_LocationID: JunctionNameDDL.ID,
            ReadingDate: Date,
            token: token,
            FromTop: '1',
            ToTop: "99999",
            M_WardID: WardName.ID,
            // PumpStation: '',
            M_UserID: 1,
            Flag: ApiFlag,
        }
        if (WardName.ID !== 0) {
            dispatch(WaterSupplyDistributionNetworkTableExportDataAPI({ data }))
        }
    }
    //  [IsPost,isSearch, IsClear])

    const { ExportTableData, isExportLoading } = useSelector(state => state.WaterSupplyDistributionNetworkTableExportData)

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleDeleteApi = (item) => {
        const data = {
            T_Distri_WS_WaterNetworkSupplyID: item.t_Distri_WS_WaterNetworkSupplyID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost
        }
        dispatch(WaterSupplyDistributionNetworkDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.WaterSupplyDistributionNetworkDelete)

    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content">

                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='col-8'>
                                <h5 className="mt-2">Water Supply Distribution Network</h5>
                            </div>
                            <div className='col-4 mar_add'>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <WaterSupplyDistributionNetworkPreventiveWorkExportData
                                                ExcelData={ExportTableData}
                                                Date={Date}
                                                name='Water Supply Distribution Network'
                                            // searchName={searchName}
                                            />
                                    }
                                </div>
                            </div>
                            <div className="row m-0 ">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">
                                            <div className="col-lg-2 col-md-3">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="ToDate"
                                                        value={Date}
                                                        onChange={(e) => setDate(e.target.value)}
                                                    />
                                                </div>

                                            </div>

                                            <div className="col-lg-3 col-md-3">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                // Flag='ward'
                                                />

                                            </div>
                                            {
                                                DashProjectTypeId == '6' ?
                                                    <>
                                                        <div className="col-lg-3 col-md-3">
                                                            <DistributionLineLocationDataDDL
                                                                DistributionLineLocationDDL={JunctionNameDDL}
                                                                setDistributionLineLocationDDL={setJunctionNameDDL}
                                                                WardName={WardName.ID}
                                                            // Flag='ward'
                                                            />
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="col-lg-3 col-md-3">
                                                        <JunctionNameDataDDL
                                                            JunctionNameDDL={JunctionNameDDL}
                                                            setJunctionNameDDL={setJunctionNameDDL}
                                                            WardName={WardName}
                                                        />

                                                    </div>
                                            }
                                            <div className="col-12 col-md-3 col-lg-3 mt-lg-4 mt-md-4 mt-1 d-flex" >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive">
                                            <TableNote />
                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th rowSpan={3}>Sr No.</th>
                                                        <th colspan="2" style={{ textAlign: "center" }} className='new_grid'>Water Consumption</th>
                                                        <th colspan="4" style={{ textAlign: "center" }}>Supply Scheduled Time</th>
                                                        <th colspan="2" style={{ textAlign: "center" }}>Quantified Of Critical Point</th>
                                                        <th colspan="2" style={{ textAlign: "center" }}>No Of Critical Point</th>
                                                        <th rowSpan={3} className='action-col'>Action</th>
                                                    </tr>
                                                    <tr>
                                                        <th rowSpan={2}>Metered</th>
                                                        <th rowSpan={2}>Un Metered</th>
                                                        <th colspan="2" style={{ textAlign: "center" }} className='new_grid'>Stipulated</th>
                                                        <th colspan="2" style={{ textAlign: "center" }} className='new_grid'>Actual</th>
                                                        <th rowSpan={2}>Required</th>
                                                        <th rowSpan={2}>Actual</th>
                                                        <th rowSpan={2}>Normal</th>
                                                        <th rowSpan={2}>Affected</th>
                                                    </tr>
                                                    <tr>
                                                        <th>Morning</th>
                                                        <th>Evening</th>
                                                        <th>Morning</th>
                                                        <th>Evening</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) =>
                                                            <tr>
                                                                <td className='sr-no-col' style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td>{item.consumptionMetered ? item.consumptionMetered : '-'}</td>
                                                                <td>{item.consumptionUnMetered ? item.consumptionUnMetered : '-'}</td>
                                                                <td>{item.stipulatedMorning ? item.stipulatedMorning : '-'}</td>
                                                                <td>{item.stipulatedEvening ? item.stipulatedEvening : '-'}</td>
                                                                <td>{item.actualMorning ? item.actualMorning : '-'}</td>
                                                                <td>{item.actualEvening ? item.actualEvening : '-'}</td>
                                                                <td>{item.criticalPointsRequired ? item.criticalPointsRequired : '-'}</td>
                                                                <td>{item.criticalPointsActual ? item.criticalPointsActual : '-'}</td>
                                                                <td>{item.criticalPointsNormal ? item.criticalPointsNormal : '-'}</td>
                                                                <td>{item.criticalPointsAffected ? item.criticalPointsAffected : '-'}</td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    {
                                                                        (moment(item.readingDate).format('YYYY-MM-DD')) == (moment().format('YYYY-MM-DD')) ?
                                                                            <>                                                                    <span>
                                                                                <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                    style={{ cursor: 'pointer' }}
                                                                                    onClick={() => handleEditOnClick(item)}
                                                                                >
                                                                                </i>
                                                                            </span>
                                                                                <span>
                                                                                    <DeletePopup
                                                                                        open={DeletePopupShow}
                                                                                        handleDeleteApi={handleDeleteApi}
                                                                                        item={item}
                                                                                    />
                                                                                </span>

                                                                            </>
                                                                            :
                                                                            '-'
                                                                    }

                                                                </td>
                                                            </tr>
                                                        ) :
                                                            <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFromTop}
                                                setTo={setToTop}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    WaterSupplyDistributionNetworkPreventiveWorkPopupShow ?
                        <WaterSupplyDistributionNetworkPreventiveWorkPopup
                            open={WaterSupplyDistributionNetworkPreventiveWorkPopupShow}
                            // popupHeading="Water Quality-Chlorine"                        
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div>
        </div>



    )
}